import {
  Message,
  ErrorMessage,
  ResponseMessage,
  ActionType,
  RequestMessage,
  AppAction,
  SDKAction,
  InternalAppAction,
} from '../../api/types/actions';

export function isAction(message: unknown): message is Message {
  return (
    message !== undefined &&
    message !== null &&
    Object.prototype.hasOwnProperty.call(message, 'actionName') &&
    Object.prototype.hasOwnProperty.call(message, 'type')
  );
}

export function isRequestMessage(message: unknown): message is RequestMessage {
  return isAction(message) && message.type.toUpperCase() === ActionType.REQUEST;
}

export function isResponseMessage(
  message: unknown
): message is ResponseMessage {
  return (
    isAction(message) && message.type.toUpperCase() === ActionType.RESPONSE
  );
}

export function isErrorMessage(message: unknown): message is ErrorMessage {
  return isAction(message) && message.type.toUpperCase() === ActionType.ERROR;
}

/** Returns whether the action name is one of app action names. */
export function isAppAction(actionName: string) {
  return (Object.values(AppAction) as string[]).includes(actionName);
}

/** Returns whether the action name is one of internal app action names. */
export function isInternalAppAction(actionName: string) {
  return (Object.values(InternalAppAction) as string[]).includes(actionName);
}

/** Returns whether the action name is one of SDK action names. */
export function isAddonAction(actionName: string) {
  return (Object.values(SDKAction) as string[]).includes(actionName);
}
